var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.973,
    height: 21.98,
    viewBox: "0 0 22.973 21.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144881",
    "data-name": "Group 144881",
    transform: "translate(0.5 0.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1832",
    "data-name": "Group 1832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M22.473,11.005c0,1.108-1.573,1.954-1.9,2.953-.336,1.036.428,2.643-.2,3.505s-2.4.638-3.273,1.271-1.183,2.385-2.219,2.722c-1,.325-2.288-.9-3.4-.9s-2.4,1.223-3.4.9c-1.036-.336-1.357-2.094-2.22-2.721s-2.64-.4-3.273-1.272.137-2.469-.2-3.505c-.325-1-1.9-1.845-1.9-2.953S2.073,9.052,2.4,8.052c.336-1.036-.428-2.643.2-3.505S5,3.909,5.871,3.275,7.055.89,8.091.554c1-.325,2.288.9,3.4.9s2.4-1.223,3.4-.9C15.919.89,16.24,2.648,17.1,3.275s2.64.4,3.273,1.272-.137,2.469.2,3.505C20.9,9.052,22.473,9.9,22.473,11.005Z",
    transform: "translate(-0.5 -0.499)",
    fill: "#4ea519",
    stroke: "#4ea518",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M0,0V4.752H8.675",
    transform: "translate(6.239 10.291) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkDark);
export default __webpack_public_path__ + "static/media/checkmarkDark.db38c2acf9a7a1c51c10e991a51267dc.svg";
export { ForwardRef as ReactComponent };